import React from 'react';
import { Target, Crosshair, Shield, Eye, Lock, Cpu } from 'lucide-react';
import './Principles.css';

const Principles = () => {
    const principles = [
        { icon: <Target size={32} />, title: 'Absolute Truth', description: 'Every insight is grounded in verifiable data and rigorous analysis.' },
        { icon: <Crosshair size={32} />, title: 'Precision', description: 'Decisions based on reality—not assumptions.' },
        { icon: <Shield size={32} />, title: 'Integrity', description: 'Ethical standards guide every solution.' },
        { icon: <Eye size={32} />, title: 'Transparency', description: 'Hidden risks exposed clearly.' },
        { icon: <Lock size={32} />, title: 'Confidentiality', description: 'Highest level of data security.' },
        { icon: <Cpu size={32} />, title: 'Innovation', description: 'Pushing boundaries of machine intelligence.' }
    ];

    return (
        <section className="principles">
            <div className="principles-container">
                <span className="section-label">Our Principles</span>
                <h2 className="principles-title">What We Stand For</h2>
                <div className="principles-grid">
                    {principles.map((principle, index) => (
                        <div key={index} className="principle-item">
                            <div className="principle-icon">{principle.icon}</div>
                            <h3>{principle.title}</h3>
                            <p>{principle.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Principles;
